module.exports = __webpack_public_path__ + "static/media/logo.4f641c92.svg";